// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LRw8","col":"styles_col__3zhbc"};